import { Reveal } from "@/components/Motion";

const Block = ({ title, children }) => (
  <Reveal className="mb-10">
    <h2 className="font-serif text-2xl md:text-3xl text-gold mb-4">{title}</h2>
    <div className="text-white/60 font-light leading-relaxed space-y-3">{children}</div>
  </Reveal>
);

export default function MentionsLegales() {
  return (
    <div className="pt-32 pb-24" data-testid="mentions-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-luxe text-gold mb-6">Informations légales</p>
          <h1 className="font-serif text-5xl md:text-6xl text-white mb-14">Mentions Légales</h1>
        </Reveal>

        <Block title="Éditeur du site">
          <p><span className="text-white">Raison sociale :</span> SYNERGIE VITA HOLDING (SAS)</p>
          <p><span className="text-white">Forme juridique :</span> Société par Actions Simplifiée (SAS)</p>
          <p><span className="text-white">Capital social :</span> 500 €</p>
          <p><span className="text-white">Siège social :</span> 55 route de la Démarche, 97233 SCHOELCHER, Martinique</p>
          <p><span className="text-white">Email :</span> gestion.svh@serenite-essence.fr</p>
          <p><span className="text-white">Directeur de la publication :</span> Rodrigue Cassildé</p>
        </Block>

        <Block title="Marque">
          <p>Le site exploite la marque « Académie AETHERIS » et la méthode « Triple Fusion™ », propriété de SYNERGIE VITA HOLDING (SAS).</p>
        </Block>

        <Block title="Hébergement">
          <p>Le site est hébergé sur une infrastructure cloud sécurisée. Toute demande relative à l'hébergement peut être adressée à l'éditeur.</p>
        </Block>

        <Block title="Propriété intellectuelle">
          <p>L'ensemble des contenus (textes, visuels, méthodes, marques) est la propriété exclusive de SYNERGIE VITA HOLDING (SAS). Toute reproduction sans autorisation est interdite.</p>
        </Block>

        <Block title="Responsabilité">
          <p>Les prestations de l'Académie AETHERIS relèvent du développement personnel et ne se substituent en aucun cas à un avis médical, psychologique, juridique ou financier.</p>
        </Block>
      </div>
    </div>
  );
}
